/* Cookie consent + Google Consent Mode v2
 * - One cookie: cookie_consent_v1
 * - GA4 loaded directly (no GTM)
 * - Meta pixel loaded directly on marketing consent
 * - Consent Mode v2 signals sent to GA4 before any tracking fires
 */

(function () {
    // ====== CONFIG ======
    var COOKIE_NAME = "cookie_consent_v1";
    var COOKIE_MAX_AGE = 60 * 60 * 24 * 180; // 180 days

    function metaContent(name) {
        var el = document.querySelector('meta[name="' + name + '"]');
        return el ? el.getAttribute("content") : null;
    }
    var GA4_ID      = metaContent("analytics:ga4");
    var FB_PIXEL_ID = metaContent("analytics:meta");

    console.log("keferboeck.com | stint.co | Your privacy matters ...")

    // ====== Cookie utils ======
    function readCookie(name){
        var m = document.cookie.match(new RegExp("(?:(?:^|.*;\\s*)"+name+"\\s*\\=\\s*([^;]*).*$)|^.*$"));
        return m && m[1] ? decodeURIComponent(m[1]) : null;
    }
    function writeCookie(name, value, maxAgeSeconds){
        var secure = location.protocol === "https:" ? "; Secure" : "";
        document.cookie = name + "=" + encodeURIComponent(value) +
            "; Path=/; SameSite=Lax; Max-Age=" + maxAgeSeconds + secure;
    }
    function defaults(){
        return {
            version: 1,
            date: new Date().toISOString(),
            categories: { essential:true, analytics:false, marketing:false, preferences:false }
        };
    }
    function getConsent(){
        try { var raw = readCookie(COOKIE_NAME); return raw ? JSON.parse(raw) : null; } catch(e) { return null; }
    }
    function saveConsent(state){
        state.date = new Date().toISOString();
        writeCookie(COOKIE_NAME, JSON.stringify(state), COOKIE_MAX_AGE);
        console.log("Keferboeck Ltd | [consent-info] wrote", state);
    }

    // ====== A11y helper (fix aria-hidden warning) ======
    function blurActive(){
        try {
            if (document.activeElement && typeof document.activeElement.blur === "function") {
                document.activeElement.blur();
            }
        } catch(e){}
    }

    // ====== GA4 direct (Consent Mode default denied) ======
    var ga4Booted = false;
    function bootGA4Once(){
        if (ga4Booted) return;
        ga4Booted = true;

        window.dataLayer = window.dataLayer || [];
        window.gtag = function(){ window.dataLayer.push(arguments); };

        // Deny everything until user chooses
        window.gtag('consent', 'default', {
            ad_storage:         'denied',
            analytics_storage:  'denied',
            ad_user_data:       'denied',
            ad_personalization: 'denied',
            wait_for_update:    500
        });

        // Load GA4 directly
        if (!GA4_ID) {
            console.warn("Keferboeck Ltd | [consent-info] GA4_ID not set — analytics:ga4 meta tag missing");
            return;
        }
        if (!document.getElementById("ga4-js")) {
            var s = document.createElement("script");
            s.id = "ga4-js";
            s.async = true;
            s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(GA4_ID);
            s.onload = function(){
                window.gtag('js', new Date());
                window.gtag('config', GA4_ID);
                console.log("Keferboeck Ltd | [consent-info] GA4 loaded");
            };
            document.head.appendChild(s);
        }
        console.log("Keferboeck Ltd | [consent-info] GA4 booted (default denied)");
    }

    // ====== Consent -> update GA4 signals ======
    function updateConsentSignals(state){
        var cats      = (state && state.categories) || {};
        var analytics = !!cats.analytics;
        var marketing = !!cats.marketing;

        if (typeof window.gtag === "function") {
            window.gtag('consent', 'update', {
                analytics_storage:  analytics ? 'granted' : 'denied',
                ad_storage:         marketing ? 'granted' : 'denied',
                ad_user_data:       marketing ? 'granted' : 'denied',
                ad_personalization: marketing ? 'granted' : 'denied'
            });
            console.log("Keferboeck Ltd | [consent-info] consent update sent", { analytics: analytics, marketing: marketing });
        } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(['consent', 'update', {
                analytics_storage:  analytics ? 'granted' : 'denied',
                ad_storage:         marketing ? 'granted' : 'denied',
                ad_user_data:       marketing ? 'granted' : 'denied',
                ad_personalization: marketing ? 'granted' : 'denied'
            }]);
            console.warn("Keferboeck Ltd | [consent-info] gtag not ready; queued consent update");
        }
    }

    // ====== Meta pixel ======
    function loadMetaPixel(pixelId){
        if (!pixelId || window.fbq) return;
        try {
            var q = [];
            var fbq = function(){ fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : q.push(arguments); };
            fbq.queue = q; fbq.version = '2.0'; fbq.loaded = true;
            window.fbq = fbq;
            fbq('init', pixelId);
            fbq('track', 'PageView');
            if (!document.getElementById("fbq-js")) {
                var s = document.createElement("script");
                s.id = "fbq-js"; s.async = true;
                s.src = "https://connect.facebook.net/en_US/fbevents.js";
                document.head.appendChild(s);
            }
            console.log("Keferboeck Ltd | [consent-info] Meta pixel loaded");
        } catch(e) { console.warn("Keferboeck Ltd | [consent-info] Meta pixel error", e); }
    }

    function applyConsent(state){
        bootGA4Once();
        updateConsentSignals(state);

        var cats = (state && state.categories) || {};
        if (cats.marketing) loadMetaPixel(FB_PIXEL_ID);
    }

    // ====== Minimal UI wiring (uses your IDs/classes) ======
    function byId(id){ return document.getElementById(id); }
    function show(el){
        if (!el) return;
        el.setAttribute("aria-hidden","false");
        el.classList.remove("opacity-0","translate-y-6");
    }
    function hide(el){
        if (!el) return;
        el.setAttribute("aria-hidden","true");
        el.classList.add("opacity-0","translate-y-6");
    }
    function backdrop(on){
        var bd = byId("cookie-consent-backdrop");
        if (!bd) return;
        if (on){
            bd.classList.remove("opacity-0"); bd.classList.add("opacity-100");
            bd.style.pointerEvents = "auto"; bd.setAttribute("aria-hidden","false");
        } else {
            bd.classList.add("opacity-0"); bd.classList.remove("opacity-100");
            bd.style.pointerEvents = "none"; bd.setAttribute("aria-hidden","true");
        }
    }
    function openBanner(){ backdrop(true); show(byId("cookie-consent-banner")); }
    function openPanel(){ blurActive(); backdrop(true); hide(byId("cookie-consent-banner")); show(byId("cookie-consent-panel")); }
    function closeAll(){ blurActive(); backdrop(false); hide(byId("cookie-consent-banner")); hide(byId("cookie-consent-panel")); }

    function persistAndApply(state){
        saveConsent(state);
        applyConsent(state);
        closeAll();
    }

    var bound = false;
    function bind(){
        if (bound) return; bound = true;

        // Always boot GA4 (default denied until consent)
        bootGA4Once();

        // If no banner on this page, still apply existing consent if present
        var banner = byId("cookie-consent-banner");
        var panel  = byId("cookie-consent-panel");

        var existing = getConsent();
        if (existing) {
            applyConsent(existing);
        } else if (banner) {
            openBanner();
        }

        if (!banner || !panel) return; // no UI present? stop here

        var btnAccept = byId("cc-accept");
        var btnReject = byId("cc-reject");
        var btnOpen   = byId("cc-customise-open");
        var btnBack   = byId("cc-customise-back");
        var btnSave   = byId("cc-save");

        if (btnAccept) btnAccept.addEventListener("click", function(){
            var c = defaults();
            c.categories.analytics   = true;
            c.categories.marketing   = true;
            c.categories.preferences = true;
            persistAndApply(c);
        });

        if (btnReject) btnReject.addEventListener("click", function(){
            persistAndApply(defaults()); // essential only
        });

        if (btnOpen) btnOpen.addEventListener("click", openPanel);
        if (btnBack) btnBack.addEventListener("click", function(){ blurActive(); hide(panel); show(banner); });

        // Sliders
        panel.addEventListener("click", function(e){
            var btn = e.target && e.target.closest ? e.target.closest(".cc-toggle") : null;
            if (!btn) return;
            var now = btn.getAttribute("aria-pressed") !== "true";
            btn.setAttribute("aria-pressed", String(now)); // styling is driven by aria-pressed in CSS
        });

        if (btnSave) btnSave.addEventListener("click", function(){
            var c = defaults();
            var toggles = panel.querySelectorAll(".cc-toggle");
            for (var i=0; i<toggles.length; i++){
                var t = toggles[i];
                var key = t.getAttribute("data-key");
                var on = t.getAttribute("aria-pressed") === "true";
                if (key) c.categories[key] = on;
            }
            persistAndApply(c);
        });
    }

    function boot(){
        try { bind(); } catch(e){ console.error("Keferboeck Ltd | [consent-info] boot error", e); }
    }

    document.addEventListener("DOMContentLoaded", boot);
    document.addEventListener("turbo:load", boot);
    document.addEventListener("turbolinks:load", boot);

    // Debug helpers
    window.__consent = {
        read: function(){ return getConsent(); },
        acceptAll: function(){ var c=defaults(); c.categories.analytics=c.categories.marketing=c.categories.preferences=true; persistAndApply(c); },
        reset: function(){ writeCookie(COOKIE_NAME,"",-1); location.reload(); }
    };
})();